/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFontFamily = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M6.448 6 2 17.632h2.144l.896-2.624h4.736l.896 2.624h2.223L8.415 6zM9.2 13.312H5.616l1.776-5.264zm8.969 3.466h.054c.11.291.303.53.581.717.283.183.659.274 1.128.274.356 0 .668-.046.937-.137.273-.096.635-.232 1.087-.41l.15-.615c-.073.032-.2.073-.383.123-.178.05-.33.075-.458.075-.291 0-.497-.048-.615-.144-.119-.1-.178-.28-.178-.54 0-.109.02-.269.062-.478.04-.214.08-.392.116-.533l1.005-4.205-.096-.109-2.099.43a2.16 2.16 0 0 0-.758-.389 3.6 3.6 0 0 0-1.074-.143c-.56 0-1.093.12-1.6.362-.505.237-.947.56-1.325.97-.374.415-.673.896-.896 1.443s-.335 1.132-.335 1.757c0 .811.2 1.451.602 1.92.4.466.998.698 1.79.698.256 0 .488-.034.698-.103.214-.063.417-.145.608-.246.22-.114.4-.228.54-.341.146-.114.299-.24.458-.376zm.827-4.69c.027.137.04.255.04.356l-.874 3.711a2.803 2.803 0 0 1-.554.465 1.14 1.14 0 0 1-.615.185c-.21 0-.385-.039-.527-.116a.872.872 0 0 1-.328-.328 1.515 1.515 0 0 1-.17-.486 3.789 3.789 0 0 1-.049-.622c0-.492.055-.973.165-1.442.109-.474.26-.889.45-1.244.197-.36.42-.647.67-.862.256-.218.534-.328.835-.328.196 0 .36.032.492.096.132.06.239.148.321.267a.893.893 0 0 1 .144.348z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgFontFamily as FontFamily };
